// :cow: Cosmose CONFIDENTIAL :iso:
import { Component } from '@angular/core';

@Component({
  selector: 'e-page-500',
  templateUrl: 'page-500.component.html',
})
export class Page500Component {
}
